module.exports = __webpack_public_path__ + "media/images/icons/bolt-3a423d13e882f83ad31e92e61f9accf6.svg";